import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export const AppConfirmDialog = ({
    open,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
}) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const handleConfirmAction = () => {
        if (typeof onConfirm === 'function') {
            onConfirm();
        }
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
         
                <Button variant='outlined' autoFocus onClick={handleClose}>
                    {cancelText || 'Disagree'}
                </Button>
                <Button variant='outlined' onClick={handleConfirmAction} autoFocus>
                    {confirmText || 'Agree'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
